var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notification',{attrs:{"items":_vm.elements,"readonly":_vm.readonly,"loading":_vm.loading},on:{"post":_vm.sendMessage,"delete-item":_vm.onDeleteItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }